import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RouteAction } from '@core/action/action';
import { TipoEntidadesEnvolvidasEnum } from '@core/models/mudanca-societaria';
import { MessageService } from '@core/services/message.service';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-entidade-envolvida-modal',
  templateUrl: './entidade-envolvida-modal.component.html',
  styleUrls: ['./entidade-envolvida-modal.component.scss']
})
export class EntidadeEnvolvidaModalComponent implements OnInit {

  @Input() idEntidade!: any;
  @Input() entidade: any;
  @Input() entidadeEnvolvida!: any;
  @Input() entidadeEnvolvidaModificada!: any;
  @Input() tipoEntidadesEnvolvidasSelecionada!: TipoEntidadesEnvolvidasEnum;
  @Input() acao!: RouteAction;
  @Output() tipoEntidadesEnvolvidasSelecionadaChange = new EventEmitter<any>();

  routeAction = RouteAction;

  constructor(
    private modalRef: NzModalRef,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    console.log("EntidadeEnvolvidaModalComponent: "+this.idEntidade);
  }

  dadosEntidadeEnvolvida(entidadeEnvolvida: any): void {
    this.entidadeEnvolvidaModificada = entidadeEnvolvida;
  }

  handleOk(): void {
    if (
      !this.entidadeEnvolvidaModificada?.entidade ||
      !this.entidadeEnvolvidaModificada?.tipoEnvolvimento ||
      !this.entidadeEnvolvidaModificada?.novoStatusEntidade
    ) {
      this.messageService.error('Por favor, preencha todos os campos obrigatórios.');
      return;
    }

    this.modalRef.close(this.entidadeEnvolvidaModificada);
  }


  handleCancel(): void {
    this.modalRef.close();
  }
}
